export default function ImagesCropController($stateParams, $state, merchantImagesService, NotificationService, IMAGES) {
  var vm = this;

  vm.isLoading = true;
  vm.merchantId = $stateParams.merchantId;
  vm.merchant = $stateParams.merchant;
  vm.items = $stateParams.data;
  vm.index = $stateParams.index;
  vm.currentItem = null;
  vm.height = 0;

  vm.cropOps = {
    aspectRatio: 1,
    resultImageFormat: 'image/jpeg',
    resultImageSize: 'max',
    areaInitSize: null,
    areaInitCoords: {
      x: 0,
      y: 0,
    },
  };

  vm.init = init;
  vm.next = next;
  vm.save = save;

  init();

  function init() {
    if (!vm.merchant) {
      $state.go(
        'app.merchant',
        {
          merchantId: vm.merchantId,
        },
        { reload: true },
      );
      return;
    }
    vm.index = 0;
    loadImage();
  }

  function next() {
    vm.isLoading = true;
    if (vm.index < vm.items.length - 1) {
      vm.index += 1;
    }
    loadImage();
  }

  function loadImage() {
    vm.currentItem = vm.items[vm.index];
    vm.currentItem.name = vm.merchant.merchant.name;

    var clientWidth = angular.element('#cropContainer')[0].clientWidth;
    var ratio = clientWidth / vm.currentItem.file.width;

    if (ratio > 1) {
      ratio = 1;
    }

    vm.height = vm.currentItem.file.height * ratio;
    setCropAreaSize(ratio);
    vm.isLoading = false;
  }

  function setCropAreaSize(ratio) {
    if (vm.currentItem.type === IMAGES.LANDSCAPE.TYPE) {
      vm.cropOps.aspectRatio = IMAGES.LANDSCAPE.ASPECT_RATIO;
      vm.cropOps.areaInitSize = {
        h: IMAGES.LANDSCAPE.MIN_HEIGHT * ratio,
        w: IMAGES.LANDSCAPE.MIN_WIDTH * ratio,
      };
    } else if (vm.currentItem.type === IMAGES.SLIDER.TYPE) {
      vm.cropOps.aspectRatio = IMAGES.SLIDER.ASPECT_RATIO;
      vm.cropOps.areaInitSize = {
        h: IMAGES.SLIDER.MIN_HEIGHT * ratio,
        w: IMAGES.SLIDER.MIN_WIDTH * ratio,
      };
    }
  }

  function save() {
    vm.isLoading = true;
    var data = vm.items.map(function(item) {
      return { name: item.name, type: item.type, sortOrder: 0, imageData: item.dataUrl };
    });

    merchantImagesService
      .uploadImages(vm.merchantId, data)
      .then(function(res) {
        if (res.data && res.data.errors) {
          if (res.data.errors.length) {
            NotificationService.warning('Some images were not saved. You can try again and upload these');
          } else {
            NotificationService.success('Your Images were successfully saved. You can now go ahead and re-order them');
          }
        }
        $state.go(
          'app.merchant',
          {
            merchantId: vm.merchantId,
            merchant: vm.merchant,
            tab: 'images',
          }
        );
      })
      .catch(function() {
        NotificationService.error('Your Images can not be saved right now. Please try again later');
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/images/images-crop.controller.js